import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap, Observable, takeUntil, throwError } from 'rxjs';
import { noncriticalHeader } from 'app/common/app-constants';
import { isNullOrUndefined } from 'app/common/utils/utils.object';
import { CancellationError } from 'app/models/errors/cancellation-error';

@Injectable()
export abstract class BaseHttpApiService {
	// Cancel request when cancellationSubject is emitted and throw an CancellationError.
	protected readonly applyCancellationSubject =
		(cancellationSubject?: Observable<void>) =>
		<T>(source: Observable<T>): Observable<T> =>
			isNullOrUndefined(cancellationSubject)
				? source
				: source.pipe(
						takeUntil(
							cancellationSubject.pipe(
								mergeMap(() =>
									throwError(() => new CancellationError())
								)
							)
						)
					);

	// Get HTTP request options
	protected getRequestOptions(noncritical?: boolean): {
		headers?: HttpHeaders;
	} {
		if (isNullOrUndefined(noncritical) || !noncritical) {
			return {};
		}

		let httpHeaders = new HttpHeaders();

		httpHeaders = httpHeaders.append(
			noncriticalHeader,
			noncritical.toString()
		);

		return {
			headers: httpHeaders
		};
	}
}
